import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import ErrorModel from '@telialt/models/src/ErrorModel';
import { axiosWithPasetoAuth } from '@telialt/utils/src/authentication/axiosWithPasetoAuth';
import { withParams } from '@telialt/utils/src/helpers';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { API } from '../api';
import { QUERY_KEYS } from '../constants';

const getSignInProgressOrderExist = (segment: TeliaSegment) => {
    return axiosWithPasetoAuth.get<boolean>(withParams(API.SIGNING_IN_PROGRESS_ORDER, { segment }));
};

export const useSignInProgressOrderExist = (enabled: boolean) => {
    const segment = useSegment();

    return useQuery<AxiosResponse<boolean>, AxiosError<ErrorModel>, boolean>({
        queryKey: [QUERY_KEYS.SIGNING_IN_PROGRESS_ORDER, segment],
        queryFn: () => getSignInProgressOrderExist(segment),
        enabled: segment === TeliaSegment.B2c && enabled,
        select: ({ data }) => data,
    });
};
